import {CustomTextField} from "../../../../../../components/CustomTextField";
import {VEHICLE_INFORMATION_LENGTH} from "../../../Model/Model";
import React from "react";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const GeneralExitRequestInformationFields = ({ materialRequest, handleChange }) => {

    return (
        <>
            <div className='col-12'>
                <CustomTextField
                    id={'txt_cea_vehicle_information'}
                    length={VEHICLE_INFORMATION_LENGTH}
                    name={'vehicleInformation'}
                    trans={'vehicle_information'}
                    value={materialRequest.vehicleInformation}
                    type={'text'}
                    disabled={false}
                    onChange={handleChange}
                    multiline={true}
                />
            </div>
        </>
    );
};

export default GeneralExitRequestInformationFields;
